import { Dispatch } from 'redux';
import actionCreatorFactory from 'typescript-fsa';
import {
    fetchConsentStatus as fetchConsentStatusService,
    fetchSubscriptions as fetchSubscriptionsService,
    NewsletterTarget,
    subscribeToNewsletter as subscribeToNewsletterFromService,
} from '@client/services/api/newsletter';
import { NAMESPACE } from './constants';
import { SubscriptionsResponse, ConsentResponse } from './types';

import * as thisModule from './actions';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingSubscriptions = actionCreator.async<null, SubscriptionsResponse, string>(
    'FETCH_SUBSCRIPTIONS',
);
export const fetchingConsent = actionCreator.async<null, ConsentResponse, string>('FETCH_CONSENT');
export const subscribing = actionCreator.async<NewsletterTarget, null, string>('SUBSCRIBE');
export const updatingNewsletterError = actionCreator<boolean>('UPDATE_NEWSLETTER_ERROR');

export const updatingNewlySubscribed = actionCreator<boolean>('UPDATE_NEWLY_SUBSCRIBED');

export const fetchSubscriptions =
    (newsltetterTarget: NewsletterTarget) => async (dispatch: Dispatch) => {
        dispatch(fetchingSubscriptions.started(null));
        try {
            const res = await fetchSubscriptionsService(newsltetterTarget);
            dispatch(fetchingSubscriptions.done({ params: null, result: res }));
        } catch (e) {
            dispatch(
                fetchingSubscriptions.failed({
                    params: null,
                    error: e,
                }),
            );
        }
    };

export const fetchConsentStatus = async (dispatch: Dispatch) => {
    dispatch(fetchingConsent.started(null));
    try {
        const res = await fetchConsentStatusService();
        dispatch(fetchingConsent.done({ params: null, result: res }));
    } catch (e) {
        dispatch(
            fetchingConsent.failed({
                params: null,
                error: e,
            }),
        );
    }
};

export const subscribeToNewsletter =
    (newsltetterTarget: NewsletterTarget) => async (dispatch: Dispatch) => {
        dispatch(subscribing.started(null));

        try {
            await subscribeToNewsletterFromService(newsltetterTarget);
            dispatch(subscribing.done({ params: newsltetterTarget }));
        } catch (e) {
            dispatch(
                subscribing.failed({
                    params: newsltetterTarget,
                    error: e,
                }),
            );
        }
    };

export const updateNewsletterError = (dispatch: Dispatch) => {
    dispatch(thisModule.updatingNewsletterError(false));
};
